import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  createBrowserRouter as reactRouterCreateBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";
import { clientEnv } from "@shared/env/browser";

const sentryDsn = clientEnv.SENTRY_DSN;
const sentryEnabled = Boolean(sentryDsn);

if (sentryEnabled && sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost",
      /\.deepscanlm\.com\//,
      /\.supabase.co\//,
      "127.0.0.1",
    ],
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0,
  });
}

type CreateBrowserRouter = typeof reactRouterCreateBrowserRouter;

const wrappedCreateBrowserRouter: CreateBrowserRouter | null = sentryEnabled
  ? (Sentry.wrapCreateBrowserRouterV7(
      reactRouterCreateBrowserRouter,
    ) as CreateBrowserRouter)
  : null;

export const createBrowserRouter: CreateBrowserRouter =
  wrappedCreateBrowserRouter ?? reactRouterCreateBrowserRouter;

export const isSentryEnabled = sentryEnabled;
export { Sentry };
